import Vue from "vue"; // 引入Vue
import VueI18n from "vue-i18n"; // 引入国际化的包
import Element from 'element-ui'
import ElementLocale from 'element-ui/lib/locale'
import enLocale from 'element-ui/lib/locale/lang/en' //引入el自带得国际化语言包,防止内部插件出现乱码
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import zhCN from 'vxe-table/lib/locale/lang/zh-CN' //引入vxe-table自带得国际化语言包,防止内部插件出现乱码
import enUS from 'vxe-table/lib/locale/lang/en-US'

Vue.use(VueI18n); // 全局注册国际化包

window.$core = window.$core || {}
window.$core.locale = localStorage.getItem('lang') === 'en-US'? 'en': "zh"

// 准备翻译的语言环境信息
const i18n = new VueI18n({
    locale: localStorage.getItem('lang') || "zh-CN", // 从session中获取语言类型 获取不到就是中文
    // silentTranslationWarn: true,
    messages: {
        'zh-CN': Object.assign(require('./zh.js'), zhLocale, zhCN),   // 中文语言包
        'en-US': Object.assign(require('./en.js'), enLocale, enUS),  // 英文语言包
    }
});

Vue.use(Element, {
    i18n: (key, value) => i18n.t(key, value)
})

ElementLocale.i18n((key, value) => i18n.t(key, value))
export default i18n